import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-applicant-ehms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-applicant-ehms.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ViewApplicationService } from "../../../view-application.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { Validators } from "@angular/forms";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ViewApplicationApplicantEhmsConstants } from "./view-application-applicant-ehms.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ApiEhmsConstants } from "../../../../../shared/constants/api-constants/api-ehms.constants";
import { finalize } from "rxjs";
let ViewApplicationApplicantEhmsComponent = class ViewApplicationApplicantEhmsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    appController;
    route;
    requestStatusService;
    recipientSelectService;
    changeDetectorRefs;
    routerParamsService;
    applicantFormControlName = ViewApplicationApplicantEhmsConstants.APPLICANT_FORMCONTROL_NAME;
    markApplicantDetailsAsNotApplicableLabel = ViewApplicationApplicantEhmsConstants.MARK_APPLICANT_DETAILS_AS_NOT_APPLICABLE_LABEL;
    markApplicantDetailsAsNotApplicableFormControlName = ViewApplicationApplicantEhmsConstants.MARK_APPLICANT_DETAILS_AS_NOT_APPLICABLE_FORMCONTROL_NAME;
    applicantForm;
    applicantDisableFilterBy = true;
    applicantDisableAdd = true;
    applicantDisableEditing = false;
    applicantShowFields = true;
    applicantIsInternal = false;
    applicantGroups = [];
    applicantLabel = "Applicant";
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    showApplicantDetails = false;
    application;
    deleteApplicantFromApplicationObservableSubscription;
    getApplicationSaveObservableSubscription;
    getApplicationsQuerySubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, appController, route, requestStatusService, recipientSelectService, changeDetectorRefs, routerParamsService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.appController = appController;
        this.route = route;
        this.requestStatusService = requestStatusService;
        this.recipientSelectService = recipientSelectService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("applicantForm");
        form.clearValidators();
        this.applicantForm = form;
        if (this.applicantForm.get("markApplicantDetailsAsNotApplicable").value === true) {
            this.showApplicantDetails = true;
            this.changeDetectorRefs.detectChanges();
        }
    }
    ngOnDestroy() {
    }
    loadMetadata(stepMeta) {
        try {
            this.applicantGroups = stepMeta.applicantGroup;
            if (this.applicantGroups[0].hasOwnProperty("requiredFields") && this.applicantGroups[0].requiredFields !== null) {
                this.applicantGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.applicantGroup);
            }
            this.changeDetectorRefs.detectChanges();
            this.getApplicantData();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    onMarkApplicantDetailsAsNotApplicableChecked(event) {
        this.showApplicantDetails = event.currentTarget.checked;
        this.updateValidation();
    }
    updateValidation() {
        const recipientControl = this.applicantForm.get(this.applicantFormControlName);
        recipientControl.clearValidators();
        if (this.showApplicantDetails) {
            recipientControl.addValidators([Validators.required]);
        }
        recipientControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onButtonSaveClicked() {
        if (this.applicantForm.valid) {
            if (this.application.applicantId !== null && !this.showApplicantDetails) {
                this.deleteApplicantFromApplicationObservableSubscription = this.viewApplicationService.deleteApplicantFromApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, ApiEhmsConstants.FUNCTION_REMOVE_APPLICANT, this.application.id).subscribe({
                    next: () => {
                        this.getApplicantData();
                    },
                    error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationApplicantEhmsConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
            }
            else if (this.showApplicantDetails) {
                const applicantFormValue = this.applicantForm.get(this.applicantFormControlName).value;
                const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
                const application = { "applicant": applicant, "applicantId": applicant.id };
                // TODO: @Lawrence - Done - Applicant Id is required for SetEHApplicant
                this.getApplicationSaveObservableSubscription = this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, application).subscribe({
                    next: () => {
                        this.getApplicantData();
                    },
                    error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationApplicantEhmsConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
            }
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getApplicantData() {
        this.applicantForm.reset();
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `applicant`
        };
        const getApplicationsQuerySubscription = this.aflaModuleStrategyService
            .getApplicationsQuery(params).pipe(finalize(() => {
            getApplicationsQuerySubscription.unsubscribe();
        })).subscribe({
            next: response => {
                if (response && response.value.length > 0) {
                    this.application = response.value[0];
                    if (this.application.applicant) {
                        this.applicantForm.get(this.markApplicantDetailsAsNotApplicableFormControlName).setValue(true);
                        this.showApplicantDetails = true;
                        const applicantControl = this.applicantForm.get(this.applicantFormControlName);
                        const applicant = this.application.applicant;
                        this.recipientSelectService.setRecipient(applicant, false, applicantControl);
                        applicantControl.markAsTouched();
                        this.changeDetectorRefs.detectChanges();
                        this.requestStatusService.removeBusySpinner("LoadingApplications");
                    }
                    else {
                        this.applicantForm.get(this.markApplicantDetailsAsNotApplicableFormControlName).setValue(false);
                        this.showApplicantDetails = false;
                    }
                    this.updateValidation();
                }
            },
            error: error => {
                this.requestStatusService.removeBusySpinner("LoadingApplications");
                this.appController.handleServerErrorMessage(ViewApplicationApplicantEhmsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: ActivatedRoute },
        { type: RequestStatusService },
        { type: RecipientSelectService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationApplicantEhmsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-applicant-ehms",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationApplicantEhmsComponent);
export { ViewApplicationApplicantEhmsComponent };
